import { useNavigate } from 'react-router-dom';

import palette from '@lib/core/src/theme/palette';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, Button, Stack, styled, SxProps } from '@mui/material';

import { useIsSmallScreen } from '@/utils/mediaUtil';

const ChildrenWrapper = styled(Stack, {
  shouldForwardProp: prop => prop !== 'isBackButtonVisible'
})<{ isBackButtonVisible?: boolean }>(({ isBackButtonVisible }) => ({
  height: isBackButtonVisible ? 'calc(100% - 50px)' : '100%'
}));

const PageContainer = ({
  children,
  backRoute,
  isBackButtonVisible = true,
  sx = {}
}: {
  children: React.ReactNode;
  backRoute?: string;
  isBackButtonVisible?: boolean;
  sx?: SxProps;
}) => {
  const navigate = useNavigate();
  const isSmallScreen = useIsSmallScreen();

  return (
    <Stack
      sx={{
        px: {
          xs: '1vw',
          md: '1vw',
          lg: '2vw'
        },
        height: '100%',
        width: '100%',
        backgroundColor: palette.globalBackground,
        margin: '0 auto',
        position: 'relative',
        paddingTop: !isBackButtonVisible && !isSmallScreen ? 'calc(2vh + 50px)' : '2vh',
        ...sx
      }}
    >
      <Stack
        sx={{
          height: '100%'
        }}
      >
        {isBackButtonVisible && (
          <Box paddingBottom="32px" height="50px">
            <Button
              startIcon={<ArrowBackIosNewIcon fontSize="small" />}
              onClick={() => (backRoute ? navigate(backRoute) : navigate(-1))}
              sx={{
                color: 'text.secondary',
                textTransform: 'none',
                p: 0,
                '&:hover': { bgcolor: 'transparent' }
              }}
            >
              Back
            </Button>
          </Box>
        )}
        <ChildrenWrapper isBackButtonVisible={isBackButtonVisible}>{children}</ChildrenWrapper>
      </Stack>
    </Stack>
  );
};

export default PageContainer;
